import { Tabs } from 'antd';
import { useStoreLimitContext } from './context';
import { useEffect, useState } from 'react';
import { getGroupByStores, getStores } from '@knowledge/common/cache/store';
import { getStoreCount } from 'components/StoreScopes';
import { convertStoreScopesToStores } from '@knowledge/common/helpers/store';
import { AdminStore } from 'services/api/admin';
import { useStoreNameConfig } from 'hooks/business/store/useStoreName';
import { useTranslate } from '@tolgee/react';
import { QueryParams } from './state';
import { useSetAtom } from 'jotai';

function SideStoreSelect() {
  const { t } = useTranslate();

  const setQueryParams = useSetAtom(QueryParams);

  const { configMap } = useStoreNameConfig();

  const { storeScopes, sideStore, setSideStore } = useStoreLimitContext();

  const [storeMap, setStoreMap] = useState<Partial<Record<number, AdminStore>>>({});

  useEffect(() => {
    getStores()
      .then((res) => {
        return !getStoreCount(storeScopes)
          ? res.slice(0, 30)
          : getGroupByStores().then((res) => {
              return convertStoreScopesToStores(storeScopes, res).slice(0, 30);
            });
      })
      .then((stores) => {
        const storeMap = stores.reduce<Partial<Record<number, AdminStore>>>((res, store) => {
          res[store.id] = store;
          return res;
        }, {});
        setStoreMap(storeMap);
      })
      .catch(() => {});
  }, [storeScopes]);

  return (
    <Tabs
      tabPosition="left"
      size="small"
      activeKey={sideStore ? `${sideStore.id}` : 'all'}
      onChange={(key) => {
        if (key === 'all') {
          setSideStore(undefined);
        } else {
          const id = Number(key);
          const { [id]: store } = storeMap;
          if (store) {
            setSideStore(store);
          }
        }
        setQueryParams((pre) => ({
          ...pre,
          pageNo: 1,
        }));
      }}
    >
      <Tabs.TabPane key="all" tab={t('全部')} />
      {Object.keys(storeMap).map((id) => {
        const { [id]: store } = storeMap;

        if (!store) {
          return null;
        }

        const { externalType, region, storeName, alias } = store;

        const isAliasFirst = configMap?.[externalType]?.[region];

        const name = isAliasFirst ? alias || storeName : storeName;

        return <Tabs.TabPane key={id} tab={name} />;
      })}
    </Tabs>
  );
}

export default SideStoreSelect;
